module.exports = __webpack_public_path__ + "static/media/S4N8.9ffd0a99.svg";